/**
 * @Date 2020/3/20 16:07
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
import Vue from 'vue'
const requireComponents = require.context('../components/AppBase', true, /\.vue|js/)
requireComponents.keys().forEach(fileName => {
  const reqCom = requireComponents(fileName)
  const reqComName = reqCom.default.name
  // if (reqComName.startsWith('Form')) {
  //   // console.log(reqComName)
  //   reqComName = reqComName.split('_')[1]
  // }
  // console.log(reqComName)
  Vue.component(reqComName, reqCom.default || reqCom)
})
